import { useHtzAhuComponentKindShowQuery } from "@/services/backend/htz/ahu/api/component-kind-api";

export function ComponentKindName({ id }: { id: string }) {
  const { data } = useHtzAhuComponentKindShowQuery({ id });

  return <span>{data?.name}</span>;
}
